let prefixURL = 'https://songsreport.com:33/api';//production
// let prefixURL = 'http://localhost:8/api';//development

const Utills = {};
function handleResponse(response) {
    if (response.status === 500) {
        return false;
    }
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            console.log('STS', response);
            if (response.status === 401) {
                // logout();
                if(localStorage.getItem('tokenme')) localStorage.removeItem('tokenme');
                Utills.navigate(`/auth/login`, { state: { from: Utills.location } })
                return data;
            }
        }
        //if(data.error) console.log('ERROR', data);
        return data;
    });
}

function Post(path, data) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
            token: localStorage.getItem('tokenme') || null
        },
        body: JSON.stringify(data)
    };
    let fullURL = `${prefixURL}${path}`;
    return fetch(fullURL, requestOptions)
        .then(handleResponse)
        .then((raw) => raw);
}

function Put(path, data) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
            token: localStorage.getItem('tokenme') || null
        },
        body: JSON.stringify(data)
    };
    let fullURL = `${prefixURL}${path}`;
    return fetch(fullURL, requestOptions)
        .then(handleResponse)
        .then((raw) => raw);
}

function Delete(path, param) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
            token: localStorage.getItem('tokenme') || null
        }
    };
    let fullURL = `${prefixURL}${path}`;
    if(param) fullURL += '?'+new URLSearchParams(param);
    return fetch(fullURL, requestOptions)
        .then(handleResponse)
        .then((raw) => raw);
}

function Get(path, param) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept':'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': 0,
            token: localStorage.getItem('tokenme') || null
        }
    };
    let fullURL = `${prefixURL}${path}`;
    if(param) fullURL += '?'+new URLSearchParams(param);
    return fetch(fullURL, requestOptions)
        .then(handleResponse)
        .then((raw) => raw);
}

const User = {};
export { Utills, Post, Put, Delete, Get, User };